import * as z from "zod/v4";

export const toggleCartValidationFunction = {
  name: "toggleCartValidationFunction" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({ success: z.boolean(), isEnabled: z.boolean() }),
};
